import React from 'react'
import { useNavigate } from 'react-router-dom'

const Back = function ({ children }) {
  const navigate = useNavigate()

  return (
    <div
      onClick={() => {
        navigate(-1)
      }}
    >
      {children}
    </div>
  )
}

export default Back
